export const GAMES_PREFIX = 'games';
export const REPLICATED_OBJECT_PATH = 'replicatedObjects';
export const ACTION_QUEUE_PATH = 'actions';
export const GAME_INITIALIZED_PATH = 'gameInitialized';
export const GAME_LIFECYCLE_PATH = 'gameLifecycle';
export const LAST_GAME_SUMMARY_PATH = 'lastGameSummary';
export const ACTION_RESULTS_PATH = 'actionResults';
export const USERS_PATH = 'users';
export const USERNAME_FIELD = 'username';
export const DESIRED_GAME_FIELD = 'desiredGame';
export const CURRENT_GAME_FIELD = 'currentGame';
export const PLAYER_ID_FIELD = 'playerId';
export const HOST_PATH = 'host';
export const PLAYERS_PATH = 'players';
export const IS_TESTING_PATH = 'isTesting';
export const SERVER_PRESENCE_PATH = 'server';
export const KILL_SERVER_PATH = 'kill';
export const SERVER_HANDOFF_PATH = 'handoff';
export const GAMES_PATH = 'games';
//# sourceMappingURL=DBPathConstants.js.map